import React, {useState} from 'react'
import TrocaComTrocoStamp from '@/modern/components/Stamps/TrocaComTroco'
import Icon from '@/modern/components/Icon'
import { SealArea, StampText, Tooltip, StrongText, Description, SealHeader } from '../style'

const TooltipSealsArea = () => {
    const [hover, setHover] = useState(false)
    const dataTestLabel = 'tooltip_trocatroco'
    
    return (
        <SealArea
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        hover={hover}
        >
            <SealHeader data-test-component={dataTestLabel}>
                <TrocaComTrocoStamp daInfo/>
                <StampText>Troca+Troco</StampText>
                <Icon name='Arrow_6' fill='#2E2D37' size='25'/>
            </SealHeader>
            <Tooltip hover={hover}>
                <Description>Troque de carro e saia com a diferença em dinheiro para usar como quiser!</Description>
            </Tooltip>
        </SealArea>
    )
}

export default TooltipSealsArea
